import { Heading, Text, VStack, Button } from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

type PublishErrorProps = {
  onBack: () => void
}

const PublishError = ({ onBack }: PublishErrorProps) => {
  const { formatMessage } = useContent()
  return (
    <CardPage trackingName="PublishError">
      <VStack spacing={3} mb={6}>
        <Text fontSize="small" lineHeight="small">
          {formatMessage({ id: 'pmportal.onboarding.oops' })}
        </Text>
        <Heading as="h1" fontSize="3xlarge" lineHeight="3xlarge">
          {formatMessage({ id: 'pmportal.onboarding.errorTitle' })}
        </Heading>
        <Text fontSize="small" lineHeight="small" color="grayscale.secondary">
          {formatMessage({ id: 'pmportal.onboarding.errorDescription' })}
        </Text>
        <Button onClick={onBack}>
          {formatMessage({ id: 'pmportal.onboarding.goBack' })}
        </Button>
      </VStack>
    </CardPage>
  )
}

export default PublishError
